export default "__VITE_ASSET__a4f49c76__"